module.exports = __webpack_public_path__ + "static/media/correct.e12c26fb.png";